import * as React from 'react';
import s from './articleView.scss';
import {
  convertToHTML,
  validateLabels
} from '../../../utils/article-utils/formatter';
import ArticleFooter from '../ArticleFooter';
import {Article} from '../../../reducers/article';
import {Experiment} from '../../../reducers/experiments';

type ArticleViewProps = {
  article: Article;
  experiments?: Experiment[];
};

class ArticleView extends React.Component<ArticleViewProps, {}> {
  render() {
    const {article, experiments} = this.props;
    const {title, date, content, labels, withMedia, id} = article;
    const approvedLabels = validateLabels(labels, experiments);
    return (
      <li
        data-hooks="single-article-view"
        className={`${s.thumbnail} ${!withMedia ? s.noMedia : ''}`}
      >
        <label data-hooks="article-date" className={s.date}>
          {date.toLowerCase()}
        </label>
        <h2 data-hooks="article-title" className={s.title}>
          {title}
        </h2>
        {convertToHTML(content)}
        <ArticleFooter
          labels={approvedLabels}
          withMedia={withMedia}
          articleId={id}
          experiments={experiments}
        />
      </li>
    );
  }
}
export default ArticleView;
